import { AudioManager } from "../../../AudioManager";
import { ColyseusManager } from "../../../ColyseusManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Button } from "../../../utils/Button";
import { BoardScene } from "../BoardScene";

export class EmojisLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.scaleY = GameVars.scaleY;

        this.x = 80;
        this.y = GameConstants.GAME_HEIGHT - 485 * GameVars.scaleY;

        const width = 118;
        const height = 690;

        const menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x132A4B, .7);
        menuBackground.fillRoundedRect(-width / 2, -height / 2 + 10, width, height, 10);
        this.add(menuBackground);

        for (let i = 0; i < 6; i ++) {

            const emoji = new Phaser.GameObjects.Image(this.scene, 0, (i - 2.5) * 108, "texture_atlas_1", "emoji_" + (i + 1));
            emoji.setInteractive();
            emoji.on("pointerover", function(): void  {
                emoji.setScale(1.075);
            }, this);
    
            emoji.on("pointerout", function(): void  {
                emoji.setScale(1);
            }, this);
    
            emoji.on("pointerdown", function(): void {
                this.onDownEmoji(i + 1);
            }, this);
            this.add(emoji);
        }

        const closeButton = new Button(this.scene, 65, -330, "texture_atlas_1", "btn_close_off", "btn_close_on");
        closeButton.setScale(0);
        closeButton.onDown(this.onClickClose, this);
        this.add(closeButton);

        this.scene.tweens.add({
            targets: closeButton,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Elastic.Out,
            duration: 350,
            delay: 350
        });

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
    }

    private onDownEmoji(i: number): void {

        AudioManager.playSound("click_btn");

        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.onEmojiSelected(i);
    }

    private onClickClose(): void {

        AudioManager.playSound("click_btn");
        
        const boardManager = BoardScene.currentInstance.boardManager;
        boardManager.hideEmojisMenu();
    }
}
